import Alpine from 'alpinejs'
import './src/images'
import './src/modernizr'

window.Alpine = Alpine
Alpine.start()
